import "./Settings.css";

export default function Settings() {
    return (
        <div className="settings">
            <h1>settings is right here</h1>
        </div>
        
    )
}